import { useQuery } from "@tanstack/react-query";
import { dashboard } from "./query";
import {
  ICirculationGridFilter,
  IDueMaterialGridFilter,
  IIssuedItemChartGridFilter,
  IMemberTypeChartGridFilter,
  IMonthlyCirculationGridFilter,
  IProgramCirculationGridFilter,
  ITitleVolumeGridFilter,
  IVisitorGridFilter,
  IRecentlyAddedBooksGridFilter,
} from "./types";
import { PostModel } from "common/models/BaseModel";

export function GetMaterialTypeWiseCount() {
  return useQuery(dashboard.getMaterialTypeWiseCount());
}

export function GetVisitors(postModel: PostModel<IVisitorGridFilter>) {
  return useQuery({
    ...dashboard.getVisitors(postModel),
  });
}

export function GetTitleVolume(postModel: PostModel<ITitleVolumeGridFilter>) {
  return useQuery({
    ...dashboard.getTitleVolume(postModel),
  });
}

export function GetCirculation(postModel: PostModel<ICirculationGridFilter>) {
  return useQuery({
    ...dashboard.getCirculation(postModel),
  });
}

export function GetProgramCirculation(
  postModel: PostModel<IProgramCirculationGridFilter>
) {
  return useQuery({
    ...dashboard.getProgramCirculation(postModel),
  });
}

export function GetDueMaterial(postModel: PostModel<IDueMaterialGridFilter>) {
  return useQuery({
    ...dashboard.getDueMaterial(postModel),
  });
}

export function GetGeneralDashboard() {
  return useQuery(dashboard.getGeneralDashboard());
}

export function GetIssuedItemChart(postModel: IIssuedItemChartGridFilter) {
  return useQuery({
    ...dashboard.getIssuedItemChart(postModel),
    enabled: postModel?.fromYear != null && postModel?.toYear != null,
  });
}

export function GetMemberTypeChart(postModel: IMemberTypeChartGridFilter) {
  return useQuery({
    ...dashboard.getMemberTypeChart(postModel),
  });
}

export function GetYearlyCirculation(filter: { instituteID: string | number | null }) {
  return useQuery({
    ...dashboard.getYearlyCirculation(filter),
  });
}

export function GetMonthlyCirculation(postModel: IMonthlyCirculationGridFilter) {
  return useQuery({
    ...dashboard.getMonthlyCirculation(postModel),
    enabled: !!postModel.year,
  });
}

export function GetRecentlyAddedBooks(
  postModel: PostModel<IRecentlyAddedBooksGridFilter>,
) {
  return useQuery({
    ...dashboard.getRecentlyAddedBooks(postModel),
  });
}

export function GetRecentlyAddedBooksSummary() {
  return useQuery(dashboard.getRecentlyAddedBooksSummary());
}
